export const tileBaseClasses = `
  group
  relative
  h-full
  flex
  flex-col
  overflow-hidden
  rounded-2xl
  transition-all duration-300
  hover:-translate-y-1

  bg-white text-neutral-900 shadow-md hover:shadow-xl
  dark:bg-neutral-900 dark:text-neutral-100
  dark:shadow-neutral-950/40
`;

export const overlayClasses = `
  absolute inset-0
  flex items-end justify-center
  px-4 pb-4
  text-center
  pointer-events-none

  bg-gradient-to-t
  from-black/70 via-black/30 to-transparent
  text-white

  dark:from-black/70 dark:via-black/40 dark:to-transparent
`;

export const popupPanelBase = `
  absolute left-0 right-0 bottom-0
 
  px-4 py-3
  text-sm font-medium
  text-white

  translate-y-[85%]
  group-hover:translate-y-0

  transition-transform duration-300 ease-out
  shadow-lg
`;

export const brandedOverlayClasses = `
  absolute inset-0
  flex items-end justify-center
  px-4 pb-4
  text-center
  pointer-events-none

  bg-gradient-to-t
  from-current via-transparent to-transparent
  text-white
`;